import { gql } from 'graphql-request'
import { useQuery } from '@/proxy/react-query'
import { timersInMilliseconds } from '@/seller.application.polling.time.config'
import { client } from '@/proxy/client'

export const LAST_ORDER_RATINGS = gql`
  query sellerLastOrderRatings {
    lastOrderRatings {
      number
      rating {
        value
        elapsedTime
      }
    }
  }
`

export const LAST_ORDER_RATINGS_KEY = 'useLastOrderRatings'

export const useLastOrderRatings = variables =>
  useQuery({
    queryKey: [LAST_ORDER_RATINGS_KEY, variables],
    queryFn: ({ signal }) => {
      return client.request({
        document: LAST_ORDER_RATINGS,
        signal,
        variables,
      })
    },
    staleTime: timersInMilliseconds.fortyFiveSeconds,
  })
